<template>
  <div class="previous-documents-table d-flex flex-grow-1 flex-wrap">
    <div class="docs-list d-flex flex-column">
      <!-- empy space -->
      <div v-if="!previousDocuments || previousDocuments.length === 0">
        This signal is based on patterns observed across multiple organizations,
        though specific matches are not available for display.
      </div>
      <div v-else class="data-container d-flex flex-column i-gap-9">
        <div
          v-for="doc of previousDocuments"
          :key="doc.id"
          class="data-table d-flex flex-column i-radius-xl i-px-9 i-py-4"
        >
          <!-- document link -->
          <signal-metadata-line title="Document">
            <template #value>
              <router-link
                v-if="doc.id"
                class="document-name"
                :to="`/customer/${doc.customer.id}/document/${doc.id}/signals`"
              >
                <div class="link-text">{{ doc.name }}</div>
              </router-link>
              <span v-else>Deleted document</span>
            </template>
          </signal-metadata-line>

          <!-- customer link -->
          <signal-metadata-line title="Customer">
            <template #value>
              <router-link
                v-if="doc.customer.id"
                :to="`/customer/${doc.customer.id}`"
              >
                <div class="link-text">
                  {{ doc.customer.name }}
                </div>
              </router-link>
            </template>
          </signal-metadata-line>

          <!-- customer link -->
          <signal-metadata-line title="Date">
            <template #value>
              <div v-if="doc.id">
                <span :id="'doc-' + doc.id">{{
                  formatFromNow(doc.created_at)
                }}</span>
                <i-tooltip
                  :target="`#doc-${doc.id}`"
                  :title="moment(doc.created_at).format(format.time_format)"
                />
              </div>
            </template>
          </signal-metadata-line>

          <!-- Owner -->
          <signal-metadata-line title="Owner">
            <template #value>
              <span v-if="doc.id">{{ doc.creator.email }}</span>
            </template>
          </signal-metadata-line>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import format from '../../../../format';
import { formatFromNow } from '@/utils/date';
import { iTooltip } from '@inscribe/signal';
import moment from 'moment';
import SignalMetadataLine from '@/V2/documents/document-view/signals/SignalMetadataLine.vue';

export default {
  components: {
    iTooltip,
    SignalMetadataLine,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    previousDocuments: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      format,
      moment,
    };
  },
  methods: {
    formatFromNow,
  },
};
</script>

<style lang="scss">
.previous-documents-table {
  .docs-list {
    width: 100%;
  }
}
</style>
